<template>
  <div class="info-classify">
    <div class="page_title flex_between">
      <span>资讯分类</span>

      <el-button type="primary"
                 style="width:92px;"
                 size="medium"
                 @click="back">返回</el-button>
    </div>

    <div class="container">
      <div class="classify-box">
        <div class="top-btn">
          <el-button type="primary"
                     icon="el-icon-plus"
                     :disabled="module_id_array[0]?!module_id_array.includes('577'):false"
                     @click="addClassify">添加资讯分类</el-button>
        </div>

        <div class="classify-table">
          <el-table ref="classifyTableRef"
                    :data="classifyTableData"
                    tooltip-effect="dark"
                    style="width: 100%;"
                    :header-cell-style="{ background: '#F5F5F5' }">
            <el-table-column v-for="item in tableHeader"
                             align="center"
                             :key="item.prop"
                             :label="item.label"
                             :prop="item.prop"
                             :width="item.width">
            </el-table-column>

            <el-table-column label="操作"
                             width="auto"
                             align="center">
              <template slot-scope="scope">
                <el-button @click="classifyEdit(scope.row)"
                           type="text"
                           :disabled=" module_id_array[0]? !module_id_array.includes('578') : false"
                           size="medium">修改</el-button>

                <el-button @click="classifyDel(scope.row)"
                           type="text"
                           :disabled="module_id_array[0] ? !module_id_array.includes('579') : false"
                           size="medium">删除</el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </div>
    </div>

    <!-- 添加/编辑 -->
    <el-dialog :title="getDialogTitle"
               width='30%'
               center
               custom-class='classify-dialog'
               :visible.sync="dialogClassify">

      <el-form :model="classifyForm"
               ref="classifyFormRef"
               :rules="classifyFormRules">
        <el-form-item label="分类名称:"
                      prop='category_name'
                      label-width="100px">
          <el-input v-model="classifyForm.category_name"
                    autocomplete="off"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="rest()">取 消</el-button>
        <el-button type="primary"
                   @click="submit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import imgtext from '../../../../api/imgtext';
export default {
  data() {
    return {
      dialogTitle: 0,
      dialogClassify: false,
      classifyForm: {
        category_name: ''
      },
      classifyFormRules: {
        category_name: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          { min: 1, max: 8, message: '分类名称8个字以内', trigger: 'blur' }
        ]
      },
      tableHeader: [
        {
          label: '分类名称',
          prop: 'category_name',
          width: 'auto'
        }
      ],
      classifyTableData: []
    };
  },
  filters: {},
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    getDialogTitle() {
      return this.dialogTitle == 0 ? '添加资讯分类' : '修改资讯分类';
    }
  },
  created() {
    this.getList();
  },
  methods: {
    addClassify() {
      this.dialogTitle = 0;
      this.classifyForm = _.omit(this.classifyForm, ['category_id']);
      this.classifyForm.category_name = '';
      this.dialogClassify = true;
    },
    classifyEdit(data) {
      let params = _.omit(data, ['is_delete']);
      this.classifyForm = params;
      this.dialogTitle = 1;
      this.dialogClassify = true;
    },
    classifyDel(data) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        imgtext
          .deleteDoctorCategoryInfo({ category_id: data.category_id })
          .then((res) => {
            let { code } = res;
            if (code == 0) {
              this.$message.success('删除成功');
              this.getList();
            }
          });
      });
    },
    submit() {
      this.$refs['classifyFormRef'].validate((valid) => {
        if (valid) {
          if (this.dialogTitle == 0) {
            imgtext.saveDoctorCategoryInfo(this.classifyForm).then((res) => {
              let { code } = res;
              if (code == 0) {
                this.$message.success('添加成功');
                this.rest();
                this.getList();
              }
            });
          } else {
            console.log(this.classifyForm);
            imgtext.editDoctorCategoryInfo(this.classifyForm).then((res) => {
              let { code } = res;
              if (code == 0) {
                this.$message.success('修改成功');
                this.rest();
                this.getList();
              }
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    rest() {
      this.$refs['classifyFormRef'].resetFields();
      this.dialogClassify = false;
    },
    // 获取资讯分类
    getList() {
      imgtext.getDoctorInfoCategoryList().then((res) => {
        let { list } = res.data;
        this.classifyTableData = list;
      });
    },
    back() {
      history.back();
    }
  }
};
</script>

<style lang="scss">
.info-classify {
  .container {
    padding: 20px;
    border-radius: 5px;
    .classify-box {
      min-height: calc(100vh - 120px);
      background: #fff;
      padding: 20px;
      .top-btn {
        text-align: left;
        margin-bottom: 20px;
      }
      .classify-table {
        border: solid 1px #c9cbd6;
        width: 600px;
        .el-table {
          min-width: 600px;
        }
      }
    }
  }
}
.classify-dialog {
    border-radius: 10px;
  .el-dialog__body {
    .el-form-item {
      margin-top: 20px;
      label {
        font-size: 16px;
      }
      .el-form-item__content {
        width: 60%;
      }
    }
  }
}
</style>